/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _50_SelectedInputs */

const en__50_selected = /** @type {(inputs: _50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 selected`)
};

const es__50_selected = /** @type {(inputs: _50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 seleccionadas`)
};

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const fr__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const de__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const ja__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const zh__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const ar__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const id__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const it__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const ru__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const pt__50_selected = en__50_selected;

/** @type {(inputs: _50_SelectedInputs) => LocalizedString} */
const ko__50_selected = en__50_selected;

/**
* | output |
* | --- |
* | "/ 50 selected" |
*
* @param {_50_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const _50_selected = /** @type {((inputs?: _50_SelectedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_50_SelectedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__50_selected(inputs)
	if (locale === "es") return es__50_selected(inputs)
	if (locale === "fr") return fr__50_selected(inputs)
	if (locale === "de") return de__50_selected(inputs)
	if (locale === "ja") return ja__50_selected(inputs)
	if (locale === "zh") return zh__50_selected(inputs)
	if (locale === "ar") return ar__50_selected(inputs)
	if (locale === "id") return id__50_selected(inputs)
	if (locale === "it") return it__50_selected(inputs)
	if (locale === "ru") return ru__50_selected(inputs)
	if (locale === "pt") return pt__50_selected(inputs)
	return ko__50_selected(inputs)
});